// Placement API calls – extracted from PlacementDetailsTableService
import axios from "axios";
import { Constants, CookieService, Utils, authansid } from '../../../shared';
import PlacementCache from './placementCache';

export const exportPlacements = (placements, camapignId, payload, versionOneApi, pmdsItems) => {
  const url = Constants.ExportPlacementsUrl;
  const placementsIdsArray = placements.map(placementObj => placementObj.id);
  let pmdsItemsArray = pmdsItems.map(pmdsItem => pmdsItem.tier_id);
  const requestUrl = url + Utils.getRouteParam("clientid") + "?campaign-id=" + camapignId + "&type=placement";
  payload['placement-ids'] = placementsIdsArray;
  payload['tier-ids'] = pmdsItemsArray;
  return axios.post(requestUrl, payload, {
    headers: {
      ansid: CookieService.getCookie("ANsid"),
      clientid: Utils.getRouteParam("clientid"),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  }).then((response) => response && response.data,
    (error) => Promise.reject(error));
};

export const checkExportJobStatus = (payload) => {
  const url = Constants.ClientDataUrl;
  const jobId = payload.jobId;
  const clientId = Utils.getRouteParam("clientid");
  const requestUrl = `${url}/${clientId}/async-job-status/${jobId}`;
  return axios.get(requestUrl, {
    headers: {
      ansid: CookieService.getCookie("ANsid"),
      clientid: Utils.getRouteParam("clientid"),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  }).then((response) => response && response.data,
    (error) => Promise.reject(error));
};

export const importPlacements = (campaignId, placementsToImports, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.post(url + '/' + campaignId + '/placements/bulk-create' + '?client-id=' + Utils.getRouteParam("clientid") + '&type=placement',
    placementsToImports,
    { headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response);
};

export const sortPlacements = (campaignName, sortColumn, sortOrder, is_deleted, filterIds, versionOneApi = 'V1') => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  let sortParams = {
    "sort-column": sortColumn,
    "sort-order": sortOrder,
    "is_delete": is_deleted
  };
  if (filterIds) {
    sortParams["placements"] = filterIds;
  }
  return axios.get(url + "/" + campaignName + "/placements?includeDeliveredTaxonomies=true", {
    params: sortParams,
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response && response.data,
    (error) => Promise.reject(error));
};

export const sendToMediaOcean = (payload, campaignId, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  let requestUrl = url + "/" + campaignId + "/placements";
  if (payload.ids.length === 1) {
    requestUrl += "/" + payload.ids[0];
    delete payload.ids;
  }
  return axios.put(requestUrl, payload, {
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const getPlacementsApproved = (campaignId, payload, pathParameters, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.put(url + "/" + campaignId + "/placements", payload, {
    params: pathParameters,
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const getPlacementsApprovedChunked = (campaignId, payload, pathParameters, versionOneApi) => {
  const CHUNK_SIZE = 300;
  const { approvedBy, isApproved, ids } = payload;

  if (!ids || ids.length === 0) {
    return Promise.reject(new Error('No placements to approve'));
  }

  if (ids.length <= CHUNK_SIZE) {
    return getPlacementsApproved(campaignId, payload, pathParameters, versionOneApi);
  }

  const chunks = [];
  for (let i = 0; i < ids.length; i += CHUNK_SIZE) {
    chunks.push(ids.slice(i, i + CHUNK_SIZE));
  }

  const chunkifiedPlacmentPromises = chunks.map((chunk, index) => {
    const chunkPayload = { approvedBy, isApproved, ids: chunk };
    return getPlacementsApproved(campaignId, chunkPayload, pathParameters, versionOneApi)
      .then(response => ({ success: true, data: response.data, chunkIndex: index + 1, chunkSize: chunk.length }))
      .catch(error => ({ success: false, error: error, chunkIndex: index + 1, chunkSize: chunk.length }));
  });

  return Promise.all(chunkifiedPlacmentPromises)
    .then(results => {
      const successfulResults = results.filter(result => result.success);
      const failedResults = results.filter(result => !result.success);

      if (failedResults.length > 0) {
        const totalPlacements = ids.length;
        const failedPlacements = failedResults.reduce((sum, result) => sum + result.chunkSize, 0);
        const successfulPlacements = totalPlacements - failedPlacements;
        const error = new Error(`Failed to approve ${failedPlacements} out of ${totalPlacements} placements. ${successfulPlacements} placements were successfully processed.`);
        error.chunkErrors = failedResults.map(result => ({
          chunkIndex: result.chunkIndex, totalChunks: chunks.length, error: result.error, chunkSize: result.chunkSize
        }));
        error.successfulChunks = successfulResults.length;
        error.totalChunks = chunks.length;
        error.totalProcessed = totalPlacements;
        error.failedPlacements = failedPlacements;
        error.successfulPlacements = successfulPlacements;
        throw error;
      }

      return {
        data: {
          updateResults: successfulResults.flatMap(result => result.data.updateResults || []),
          totalProcessed: ids.length,
          chunksProcessed: chunks.length
        },
        status: 200
      };
    });
};

export const bulkPlacementsCopy = (campaignId, payload, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.post(url + '/' + campaignId + '/placements/copy', payload, {
    headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const getPlacementsWithDelivered = (campaignId, filterObj, versionOneApi, hasNext = null, sourceSystem) => {
  let url = '';
  let firlterParams = { includeDeliveredTaxonomies: true, show_creatives: "distributed" };
  if (sourceSystem) {
    firlterParams.source_system = sourceSystem;
  }
  if (hasNext) {
    url = hasNext;
    firlterParams = {};
  } else {
    url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}/${campaignId}/placements` : `${Constants.CampaignDataUrlV2}/${encodeURIComponent(campaignId)}/placements`;
    if (filterObj) {
      if (filterObj?.parent_amd_campaign_id) {
        url = `${url}?parent_amd_campaign_id=${filterObj?.parent_amd_campaign_id}`;
        firlterParams = { ...filterObj.firlterParams, is_delete: filterObj.is_delete, page_no: filterObj.page_no, page_size: filterObj.page_size, ...firlterParams };
      } else {
        firlterParams = { ...filterObj, ...firlterParams };
      }
    }
  }
  return axios.get(url, {
    params: { ...firlterParams, "pmds-version": "v3"  },
    headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response)
    .catch((error) => Promise.reject(error));
};

export const getPlacementsWithDeliveredCached = async (campaignId, filterObj, versionOneApi, ttlMs = 60 * 60 * 1000) => {
  const defaultParams = { includeDeliveredTaxonomies: true, show_creatives: 'distributed', is_delete: false };
  let normalizedFilter = {};
  if (!filterObj) {
    normalizedFilter = { ...defaultParams };
  } else if (typeof filterObj === 'object') {
    if (filterObj.firlterParams && typeof filterObj.firlterParams === 'object') {
      normalizedFilter = { ...defaultParams, ...filterObj.firlterParams };
    } else {
      normalizedFilter = { ...defaultParams, ...filterObj };
    }
  } else {
    normalizedFilter = { ...defaultParams };
  }

  if (normalizedFilter.page_no !== undefined) delete normalizedFilter.page_no;
  if (normalizedFilter.page_size !== undefined) delete normalizedFilter.page_size;

  const key = PlacementCache.makeKey(campaignId, normalizedFilter, versionOneApi);
  const inflight = PlacementCache.getInFlight(key);
  if (inflight) return inflight;

  const p = (async () => {
    const cached = await PlacementCache.get(key).catch(() => null);
    if (cached) {
      return { data: { Items: cached, paging: { next: null } } };
    }
    let accum = [];
    let next = null;
    do {
      const resp = await getPlacementsWithDelivered(campaignId, filterObj, versionOneApi, next);
      const items = resp?.data?.Items || resp?.data || [];
      if (Array.isArray(items)) accum = accum.concat(items);
      const hasNext = resp?.data?.paging?.next;
      next = hasNext || null;
    } while (next);
    await PlacementCache.set(key, accum, ttlMs).catch(() => {});
    return { data: { Items: accum, paging: { next: null } } };
  })();

  PlacementCache.setInFlight(key, p);
  try {
    const res = await p;
    return res;
  } finally {
    PlacementCache.clearInFlight(key);
  }
};

export const deletePlacement = (campaignId, payload, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.put(url + '/' + campaignId + '/placements', payload, {
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const downloadPlacementTemplate = () => {
  const url = `${Constants.PlacementTemplateUrl}/placement-templates/${Utils.getRouteParam("clientid")}?type=placement&default=true`;
  return axios.post(url, {}, {
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then(response => response.data);
};

export const uploadPlacementTemplate = (fileData) => {
  const url = `${Constants.PlacementTemplateUrl}/import-template/${Utils.getRouteParam("clientid")}`;
  return axios.post(url, fileData, {
    headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
  }).then(response => response.data);
};
